import { render, staticRenderFns } from "./BatchUserUploadToolEditRecords.vue?vue&type=template&id=8ec84756&scoped=true&"
import script from "./BatchUserUploadToolEditRecords.vue?vue&type=script&lang=js&"
export * from "./BatchUserUploadToolEditRecords.vue?vue&type=script&lang=js&"
import style0 from "./BatchUserUploadToolEditRecords.vue?vue&type=style&index=0&id=8ec84756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec84756",
  null
  
)

export default component.exports